var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "authorization" }, [
    _c("h6", { staticClass: "text-center" }, [
      _vm._v("授权书 "),
      _c(
        "a",
        {
          staticClass: "color-success",
          attrs: { href: "javascript:void (0)" },
          on: { click: _vm.downloadApplyFile }
        },
        [_vm._v("授权书模板下载")]
      )
    ]),
    _c("div", { staticClass: "upload-file" }, [
      _vm.file.fileUrl
        ? _c("div", { staticClass: "file-box" }, [
            _c("img", { attrs: { src: _vm.file.fileUrl } })
          ])
        : _vm._e(),
      !_vm.disabledSub
        ? _c("input", {
            attrs: { disabled: !!_vm.file.fileUrl, type: "file" },
            on: { change: _vm.uploadFile }
          })
        : _vm._e()
    ]),
    _c(
      "div",
      { staticClass: "text-center btn" },
      [
        _c(
          "el-button",
          {
            attrs: { disabled: _vm.disabledSub, type: "danger" },
            on: { click: _vm.queryUploadApplyFile }
          },
          [_vm._v("确定提交")]
        ),
        _c("span", { staticStyle: { "margin-left": "8px" } }, [
          _vm._v(_vm._s(_vm.applyStatus))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0e07e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0e07e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signSettings/authorization.vue
// module id = oNAo
// module chunks = 214